export const OPEN_EXPORT_ORDERS_MODAL = 'OPEN_EXPORT_ORDERS_MODAL';
export const openExportOrdersModal = (filters) => ({
  type: OPEN_EXPORT_ORDERS_MODAL,
  filters,
});

export const EXPORT_ORDERS_REQUEST = 'EXPORT_ORDERS_REQUEST';
export const exportOrdersRequest = (
  viewRecordsOrSelectedRecords,
  primaryRecordsOrLineItems,
  searchTerm,
  filters,
  isOnAdvancedSearch,
  intl,
) => ({
  type: EXPORT_ORDERS_REQUEST,
  viewRecordsOrSelectedRecords,
  primaryRecordsOrLineItems,
  searchTerm,
  filters,
  isOnAdvancedSearch,
  intl,
});

export const EXPORT_ORDERS_SUCCESS = 'EXPORT_ORDERS_SUCCESS';
export const exportOrdersSuccess = (jobId, initiatedByUserId) => ({
  type: EXPORT_ORDERS_SUCCESS,
  jobId,
  initiatedByUserId,
});

export const EXPORT_ORDERS_COMPLETE = 'EXPORT_ORDERS_COMPLETE';
export const exportOrdersComplete = (messageGuid, data) => ({
  type: EXPORT_ORDERS_COMPLETE,
  messageGuid,
  data,
});

export const EXPORT_ORDERS_CLEANUP = 'EXPORT_ORDERS_CLEANUP';
export const exportOrdersCleanup = (jobId) => ({
  type: EXPORT_ORDERS_CLEANUP,
  jobId,
});

export const CUSTOM_EXPORT_ORDERS_REQUEST = 'CUSTOM_EXPORT_ORDERS_REQUEST';
export const customExportOrdersRequest = (
  viewRecordsOrSelectedRecords,
  extractId,
  selectedOrderIds,
  searchTerm,
  filters,
  isOnAdvancedSearch,
  intl,
) => ({
  type: CUSTOM_EXPORT_ORDERS_REQUEST,
  viewRecordsOrSelectedRecords,
  extractId,
  selectedOrderIds,
  searchTerm,
  filters,
  isOnAdvancedSearch,
  intl,
});
